module.exports = __webpack_public_path__ + "assets/3ffd425ea0f2eecb19f325929a993cdf.png";